<template>
  <div class="dashboard-editor-container">
    <panel-group />
    <el-row :gutter="32">
      <el-col :xs="24" :sm="24" :lg="8">
        <el-card>
          <div class="e-title">商品浏览量排行</div>
          <el-table :data="list" style="width: 100%;padding-top: 15px">
            <el-table-column label="排名" type="index" align="left" />
            <el-table-column label="商品名称" min-width="200">
              <template slot-scope="scope">
                <el-link :underline="false">{{ scope.row.product }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="浏览量" prop="pv" width="100" align="center" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="16">
        <el-card>
          <div class="e-title">用户登录统计</div>
          <div class="chart-wrapper">
            <div id="access" class="chart" style="height:300px;width:100%" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import API from "../../api/frbasicapi/taskmanager"
import PanelGroup from '@/components/PanelGroup'
import * as echarts from "echarts"
import Api from '../../api/sys/config'

export default {
  components: {
    PanelGroup
  },
  data() {
    return {
      loading: false,
      chart: null,
      list: [],
      logindatas: [],
    }
  },
  methods: {
    //获取用户列表
    search: function () {
      let params = {
        pageNum: 1,
        pageSize: 10,
      };
      let that = this;
      that.loading = true;
      API.list(params).then(
        function (result) {
          that.loading = false;
          if (result && result.data.totalSize) {
            if (result.data.totalSize > 0) {
              that.open2(
                "<strong>您有<a href='#/sys/frbasictask/index'>" +
                result.data.totalSize +
                "</a>条任务待处理哟</strong>"
              );
            }
          }
        },
        function (err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000,
          });
        }
      )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    open2(msg) {
      this.$notify({
        title: "任务提醒",
        dangerouslyUseHTMLString: true,
        message: msg,
        duration: 5000,
      });
    },

    //初始化浏览量排名
    initRank: function () {
      let that = this
      Api.goodsRank().then(
        function (result) {
          if (result) {
            that.list = result.data;
          }
        },
        function (err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000,
          });
        }
      )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    //初始化登录统计
    initLogin: function () {
      let that = this
      Api.loginRank().then(
        function (result) {
          if (result) {
            that.initChart(result.data)
          }
        },
        function (err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000,
          });
        }
      )
    },



    //初始化访问线状图
    initChart: function (datas) {
      this.chart = echarts.init(document.getElementById('access'))
      let data = {}
      let time = []
      let pc = []
      let pwd = []
      let mobile = []
      datas.forEach(item => {
        time.push(item.time)
        pc.push(item.pc)
        pwd.push(item.pwd)
        mobile.push(item.mobile)
      })
      data.time = time
      data.pc = pc
      data.pwd = pwd
      data.mobile = mobile
      this.setOptions(data)

    },

    setOptions({ time, pc, pwd,mobile } = {}) {
      this.chart.setOption({
        xAxis: {
          data: time,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        legend: {
          data: ['PC账号登录', 'WX账号登录','WX验证码登录']
        },
        series: [
          {
            name: 'PC账号登录',
            smooth: true,
            type: 'line',
            itemStyle: {
              normal: {
                color: '#FF005A',
                lineStyle: {
                  color: '#FF005A',
                  width: 2
                }
              }
            },
            data: pc,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          },
          {
            name: 'WX账号登录',
            smooth: true,
            type: 'line',
            itemStyle: {
              normal: {
                color: '#3888fa',
                lineStyle: {
                  color: '#3888fa',
                  width: 2
                },
                areaStyle: {
                  color: '#f3f8ff'
                }
              }
            },
            data: pwd,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          },
          {
            name: 'WX验证码登录',
            smooth: true,
            type: 'line',
            itemStyle: {
              normal: {
                color: '#1f3d22',
                lineStyle: {
                  color: '#1f3d22',
                  width: 2
                },
                areaStyle: {
                  color: '#f3f8ff'
                }
              }
            },
            data: mobile,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          }]
      })
      let chart = this.chart
      window.addEventListener("resize", function () {
        chart.resize();
      });
    },
  },

  mounted() {
    this.search()
    this.initLogin()
    this.initRank()
  },
};
</script>

<style lang="scss" scoped>
.content-title {
  clear: both;
  font-weight: 400;
  line-height: 50px;
  padding: 5px 5px;
  font-size: 18px;
  color: #1f2f3d;
}

.dashboard-editor-container {
  padding: 10px;
  background-color: rgb(240, 242, 245);
  position: relative;
  border-radius:9px;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width:1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
